import {Link, useHistory} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../../setup'
import { addDaysAndFormat } from '../../../../helpers/FormatDate'

export default function PaymentSuccessPage() {
  const {user} = useSelector((state: RootState) => state.auth, shallowEqual)
  const firstName = user?.firstName || 'User'
  const history = useHistory()

  return (
    <div className='payment-content'>
      {/* Card */}
      <div className='payment-card'>
        <h2 className='payment-card__title'>
          Thank you, {firstName}! <br /> Your payment has been received.
        </h2>

        <p className='payment-card__desc'>
          To ensure your exclusive spot and full platform access after launch, please complete your
          member profile and upload your experiences by June 30, 2026.
        </p>

        {/* Divider */}
        <div className='nbx-lines' aria-hidden='true'>
          <span className='nbx-lines__line' />
          <span>
            <img src='/media/svg/nobilis/mark.svg' alt='divider' className='payment-card__icon' />
          </span>
          <span className='nbx-lines__line' />
        </div>

        {/* assistant */}
        <div className='w-100 d-flex flex-column'>
          <p className='payment-card__desc'>
            For assistance, contact your dedicated Nobilis representative:
          </p>
          <div className="payment-complete-container mt-4">
            <div className="payment-complete-name">Vilma Bareikaite</div>

            <div className="payment-complete-row">
              {/* <div className="payment-complete-column">
                <div className="payment-complete-label">Phone</div>
                <div className="payment-complete-value">+578 23728137</div>
              </div> */}

              <div className="payment-complete-column w-100">
                <div className="payment-complete-label">Email</div>
                <div className="payment-complete-value">vilma@joinnobilis.com</div>
              </div>
            </div>
          </div>
        </div>

        {/* Botón */}
        <div onClick={()=>window.location.reload()} className='btn nb-btn-outline'>
          <span className='nb-heading-md'>COMPLETE PROFILE</span>
          <img
            src='/media/svg/nobilis/vector1.svg'
            alt=''
            className='nb-btn-icon nb-btn-icon--black'
          />
        </div>
        {/* boton logout temporal */}
        {/* <div className='btn nb-btn-outline'  onClick={()=>history.push('/logout')}>
          <span className='nb-heading-md'>CLOSE</span>
          <img
            src='/media/svg/nobilis/vector1.svg'
            alt=''
            className='nb-btn-icon nb-btn-icon--black'
          />
        </div> */}
      </div>
    </div>
  )
}
